import { useSuspenseQuery } from '@tanstack/react-query'

import { nationalAndFallbackPromotionsQuery } from './promotions'

export const useAdminPromotionList = (params: { initiativeId: string }) => {
  const { data: state } = useSuspenseQuery(nationalAndFallbackPromotionsQuery(params.initiativeId))
  return state
}
